import apiHandler from "../core/apiHandler";

const haciendaApi = apiHandler("hacienda");

export default haciendaApi;